import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  render() {
    let header = [
      <a href="#/localMerchant/home">我的店铺</a>,
      <a href="#/localMerchant/myShop">商家等级</a>,
      '等级规则'
    ]
    return (
      <HeaderView title="等级规则" header={header}>
        <div className={styles.box}>
          <div className={styles.wrap}>
            <h3>等级说明</h3>
            <dl>
              <dt>
                <span />什么是商家等级
              </dt>
              <dd>
                商家等级是婚礼纪针对商家成长推出的等级制度，分为普通商家、铜牌商家、银牌商家、金牌商家、钻石商家五个等级。不同的商家等级享有的平台资源特权不同，等级越高享有的特权资源越多。
              </dd>
            </dl>
            <dl>
              <dt>
                <span />商家升级降级规则
              </dt>
              <dd>1.评定时间：以自然日为单位，对商家等级进行评定。</dd>
              <dd>2.升级规则：不设升降限制幅度。</dd>
              <dd>3.降级规则：不设降级幅度限制。</dd>
              <dd>
                <b>注：</b>基础版店铺只可升级，不可使用特权，且婚礼纪用户端不展示等级。专业版店铺可升级与使用相关特权，且当等级达到银牌及以上时会在婚礼纪用户端展示等级标识。
              </dd>
            </dl>
          </div>

          <div className={styles.wrap} style={{ margin: '20px 0' }}>
            <h3>如何提升等级</h3>
            <dl>
              <dt>
                <span />用户互动
              </dt>
              <dd>
                商家及时快速地回复用户私信、响应用户预约、回答用户的“问大家”提问，有助于提升等级
              </dd>
              {/*<dd>建议优质套餐数量不少于{num[property]}个</dd>*/}
              {/*<dd><a href="#/localMerchant/myShop/package">手把手教你怎么发布优质套餐 》</a></dd>*/}
            </dl>
            <dl>
              <dt>
                <span />口碑积累
              </dt>
              <dd>
                考核期内，商家通过优质的服务积累优质好评，且能在产生差评时快速响应、积极回复，有助于提升等级
              </dd>
              {/*<dd>考核期内，创建新的优质案例，有助于提升等级</dd>*/}
              {/*<dd><a href="#/localMerchant/myShop/case">手把手教你怎么发布优质案例 》</a></dd>*/}
            </dl>
            <dl>
              <dt>
                <span />优质套餐
              </dt>
              <dd>
                商家为婚礼纪用户提供全渠道最具性价比的套餐，价格合理，且与线下的更新节点保持同步，有助于提升等级；建议优质套餐数量不少于3个
              </dd>
              {/*<dd>考核期内，坚持每天发布新动态，有助于提升等级</dd>*/}
              {/*<dd><a href="#/localMerchant/myShop/dynamic">什么样的优质动态可以上首页 》</a></dd>*/}
            </dl>
            <dl>
              <dt>
                <span />新鲜内容
              </dt>
              <dd>
                考核期内，商家通过案例和动态功能坚持发布优质的原创作品，或备婚干货、日常花絮等，有助于提升等级
              </dd>
              {/*<dd>考核期内，坚持订单在线成交并累积好评，有助于提升等级</dd>*/}
            </dl>
            <dl>
              <dt>
                <span />在线交易
              </dt>
              <dd>考核期内，商家积极引导婚礼纪用户在线成交，有助于提升等级</dd>
              {/*<dd>考核期内，坚持每天登录商家后台并及时回复私信，有助于提升等级</dd>*/}
            </dl>
            <dl>
              <dt>
                <span />流量转化
              </dt>
              <dd>
                商家通过优化套餐质量或打造爆款套餐，从而提升曝光到点击的转化率，有助于提升等级
              </dd>
              {/*<dd>考核期内，可以设置的营销工具全部设置，有助于提升等级</dd>*/}
            </dl>
            <dl>
              <dt>
                <span />运营配合
              </dt>
              <dd>
                商家保持与婚礼纪运营人员的良好沟通，积极参与平台活动，有助于提升等级
              </dd>
              {/*<dd>考核期内，及时快速的回复客户私信信息，有助于提升等级</dd>*/}
            </dl>
            <dl>
              <dt>
                <span />店铺服务&放心购·保证金
              </dt>
              <dd>开通店铺服务，用户端显示等级标识</dd>
              {/*<dd>考核期内，新上线聚客宝活动，有助于提升等级</dd>*/}
            </dl>
            {/*<dl>*/}
            {/*<dt><span></span>保证金</dt>*/}
            {/*<dd></dd>*/}
            {/*/!*<dd>成为保证金商家，有助于提升等级</dd>*!/*/}
            {/*</dl>*/}
          </div>

          <div className={styles.wrap}>
            <h3>
              哪些是违规行为
              <a
                style={{ float: 'right' }}
                href="#/localMerchant/myShop/illegal"
              >
                查看我的违规记录 》
              </a>
            </h3>
            <dl>
              <dd>1.商家被判投诉成立；</dd>
              <dd>2.商家有刷单行为；</dd>
              <dd>3.商家有逃单行为;</dd>
              <dd>4.动态内容不合规被删除。</dd>
              <dd>5.超过24小时未处理预约。</dd>
              <dd>6.恶意拒单。</dd>
            </dl>
          </div>
        </div>
      </HeaderView>
    )
  }
}
